import * as THREE from 'three'
import React from 'react'

const VRMain = React.memo(({ loaded, map, setLoaded, visible = false }) => {
    if (!map) return <mesh />
    const geometry = new THREE.SphereBufferGeometry(500, 60, 40);

    let manager = new THREE.LoadingManager();

    manager.onStart = function ( url, itemsLoaded, itemsTotal ) {
    };
    
    manager.onLoad = function ( ) {
        setTimeout(() => {
            setLoaded(true)
        }, 100);
    };
    
    
    manager.onProgress = function ( url, itemsLoaded, itemsTotal ) {
    };
    
    manager.onError = function(map) {
        console.log('Error loading texture: ' + map);
    };


    const texture = new THREE.TextureLoader(manager).load(
        map
      );

    texture.minFilter = THREE.LinearFilter
    texture.magFilter = THREE.LinearFilter
    const debugXYZ = false
    return (
        <mesh 
            geometry={geometry}
            position={[0, 0, 0]} 
            scale={[1, 1, -1]} 
            onClick={(e) => debugXYZ && console.log('canvas', [e.point.x.toFixed(0), e.point.y.toFixed(0), e.point.z.toFixed(0)])}
        >
            <meshBasicMaterial visible={loaded && visible} map={texture} side={THREE.BackSide} opacity={1} transparent={false} precision='highp' needsUpdate={false} />
        </mesh>
    )
})

export default VRMain